"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullscreenModalLayout = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./FullscreenModalLayout.css"));
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FullscreenModalLayout = props => {
  const {
    children,
    onClose
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: style['layout']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['close-button']
  }, /*#__PURE__*/React.createElement(_uiKit.IconButton, {
    icon: /*#__PURE__*/React.createElement(_icons.IconActionClose12, null),
    onClick: onClose
  })), children);
};
exports.FullscreenModalLayout = FullscreenModalLayout;